import React from "react";
import styles from "./style.module.css";
import Logo from "../logo";
import logo from "../../assets/images/whitelogo.png";
import Carwash from "../../assets/images/carwash.png";
import CarwashVector from "../../assets/images/curve.png";

const LoginLeftBg = () => {
  return (
    <div className={styles.login_left_bg}>
      <img src={CarwashVector} alt="carwash" />
      <div className={styles.login_left_bg_container}>
        <div className={styles.login_logo}>
          <Logo logoImg={logo} />
        </div>
        <div className={styles.login_outer}>
          <div className={styles.login_title}>
            Rev Up Your Ride with Dashbook: The Ultimate Car Services Solution!"
          </div>
          <div className={styles.login_vetor}>
            <img src={Carwash} alt="carwash" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginLeftBg;
